import { secondsFormat } from "lib/bookUtils";
import { ReadingFormatByID } from "types/ReadingFormatType";
import { dateFormat } from "lib/dateFormat";
import { EditionSerializersEdition } from "types/serializers";
import EditionType from "types/EditionType";

export interface BookDataPair {
  title: string;
  value: string;
}

export default function generateEditionData(
  edition: EditionSerializersEdition | EditionType
): BookDataPair[] {
  const data: BookDataPair[] = [
    {
      title: "Type",
      value: edition.readingFormatId
        ? ReadingFormatByID[edition.readingFormatId].format
        : null,
    },
    {
      title: "Language",
      value: edition.language ? edition.language.language : null,
    },
    {
      title: "Pages",
      value: edition.pages ? edition.pages.toLocaleString() : null,
    },
    {
      title: "Audio Length",
      value: edition.audioSeconds ? secondsFormat(edition.audioSeconds) : null,
    },
    {
      title: "Format",
      value: edition.editionFormat,
    },
    {
      title: "Information",
      value: edition.editionInformation,
    },
    {
      title: "Release Date",
      value: edition.releaseDate ? dateFormat(edition.releaseDate) : "Unknown",
    },
    {
      title: "ISBN 10",
      value: edition.isbn10,
    },
    {
      title: "ASIN",
      value: edition.asin,
    },
    {
      title: "ISBN 13",
      value: edition.isbn13,
    },
    {
      title: "Readers",
      value: edition.usersCount > 0 ? edition.usersCount : null,
    },
    {
      title: "Country",
      value: edition.country?.name ? edition.country.name : null,
    },
  ].filter(({ value }) => value);

  return data;
}
